/* eslint quotes: 'off' */

import apiHelper from '@/scripts/crossTabulation/apiHelper';
export default {
    loadWithPromise
}

function loadWithPromise(jsonFileName, isFullUrl) {
    return new Promise((resolve, reject) => {
        promiseCallApi({jsonFileName, isFullUrl }, resolve, reject)
    });
}

function promiseCallApi({jsonFileName, isFullUrl}, resolve, reject) {
    const defaultErrorMessage = null;
    apiHelper.callGet({
        //url: isFullUrl ? jsonFileName : process.env.BASE_URL + jsonFileName,
        url: jsonFileName,
        success: function (response) { resolve(response); },
        error: function (jqXHR) {
            dataLoadFailed({ jqXHR, defaultErrorMessage, jsonFileName });
            reject();
        }
    });
}


function dataLoadFailed({ jqXHR, message, jsonFileName }) {
    console.log('data load failed for ' + jsonFileName, jqXHR );
    return true;
}


//Here's how to do a promise
//https://stackoverflow.com/questions/42958334/how-can-i-export-promise-result

//https://www.w3schools.com/js/js_promise.asp

//https://stackoverflow.com/questions/7307983/while-variable-is-not-defined-wait

//Search
//https://www.google.com/search?q=site%3Astackoverflow.com+How+to+load+external+scripts+dynamically+in+vue.js&rlz=1C1OKWM_enUS909US909&oq=site%3Astackoverflow.com+How+to+load+external+scripts+dynamically+in+vue.js&aqs=chrome..69i57j69i58.6911j0j7&sourceid=chrome&ie=UTF-8